!((document, Drupal, $, debounce) => {
  'use strict';

  /**
   * Toggle both megamenu and mobile menus in header.
   */
  Drupal.behaviors.header = {
    attach: function(context) {
      const $headerContainer = $('.header', context);

      // Only run once.
      if (!$headerContainer.length) {
        return;
      }

      const $adminToolbar = $('#toolbar-bar');
      const $toolBarTray = $('.toolbar-tray-horizontal.is-active');
      const $envIndicator = $('#environment-indicator');
      const $alertMessage = $('header .alert-message');
      const $mobileHeader = $('.header__row-top');
      const $marketMenu = $('.header__market-menu');
      const $megamenu = $('.header__megamenu');
      const $megamenuToggleBtn = $('.header__menu-toggle');
      const $mobileToggleBtn = $('.header__mobile-toggle');
      const $mobileRow = $('.header__row-bottom');

      $(document).ready(function() {
        let adminHeight = $adminToolbar.length > 0 ? 39 : 0;
        let toolbarTrayHeight =
          $toolBarTray.length > 0 ? $toolBarTray.outerHeight() : 0;
        let envHeight = $envIndicator.length > 0 ? 34 : 0;
        let alertHeight =
          $alertMessage.length > 0 && !$alertMessage.hasClass('dismissed')
            ? $alertMessage.outerHeight()
            : 0;
        let mobileHeaderHeight =
          $mobileHeader.length > 0 ? $mobileHeader.outerHeight() : 0;
        let desktopHeaderHeight =
          $headerContainer.length > 0 ? $headerContainer.outerHeight() : 0;

        // Create empty variables to use later for calculating heights.
        let $combinedHeights = 0;
        let $desktopMenuHeight;

        /**
         * @param {string} breakpoint - The window's breakpoint.
         * @returns {any} Calculates Height
         */
        function combineHeights(breakpoint) {
          adminHeight =
            $adminToolbar.length > 0 ? $adminToolbar.outerHeight() : 0;
          toolbarTrayHeight =
            $toolBarTray.length > 0 ? $toolBarTray.outerHeight() : 0;
          envHeight =
            $envIndicator.length > 0 ? $envIndicator.outerHeight() : 0;
          alertHeight =
            $alertMessage.length > 0 && !$alertMessage.hasClass('dismissed')
              ? $alertMessage.outerHeight()
              : 0;
          mobileHeaderHeight =
            $mobileHeader.length > 0 ? $mobileHeader.outerHeight() : 0;
          desktopHeaderHeight =
            $headerContainer.length > 0 ? $headerContainer.outerHeight() : 0;

          if (breakpoint === 'tablet') {
            if ($megamenuToggleBtn.hasClass('is-active')) {
              $combinedHeights =
                desktopHeaderHeight +
                adminHeight +
                alertHeight +
                envHeight +
                toolbarTrayHeight;
            }
            else {
              $combinedHeights = 0;
            }
          }
          else if (breakpoint === 'mobile') {
            if ($mobileToggleBtn.hasClass('is-active')) {
              $combinedHeights = mobileHeaderHeight;
            }
            else {
              $combinedHeights = 0;
            }
          }
        }

        /**
         * @returns {any} Toggles Megamenu for Tablet and Desktop
         */
        function tabletDesktopMenuToggle() {
          $megamenuToggleBtn.toggleClass('is-active');
          $megamenu
            .toggleClass('is-active')
            .attr('aira-expanded', true)
            .attr('aria-hidden', false);
          $marketMenu.toggleClass('is-active');
          $mobileRow.removeClass('is-active');
          $mobileToggleBtn.removeClass('is-active');
          $headerContainer.toggleClass('is-active');

          if ($megamenuToggleBtn.hasClass('is-active')) {
            $desktopMenuHeight =
              $headerContainer.outerHeight() + $megamenu.outerHeight();

            combineHeights('tablet');
            $('body').css({ overflow: 'hidden', position: 'fixed' });
          }
          else {
            $combinedHeights = 0;
            $('body').css({ overflow: 'auto', position: 'relative' });
          }

          if ($(window).innerHeight() < $desktopMenuHeight) {
            // Set megamenu max-height.
            $megamenu.css({
              'max-height': `calc(100% - ${$combinedHeights}px)`,
              height: `calc(100vh - ${$combinedHeights}px)`
            });
          }
          else {
            $megamenu.css({
              'overflow-y': 'auto',
              height: `calc(100vh - ${$combinedHeights}px)`
            });
          }
        }

        /**
         * @returns {any} Toggles Megamenu for Mobile
         */
        function mobileMenuToggle() {
          $mobileToggleBtn.toggleClass('is-active');
          $mobileRow.toggleClass('is-active');
          $headerContainer.toggleClass('is-active');
          $megamenuToggleBtn.removeClass('is-active');

          if ($mobileToggleBtn.hasClass('is-active')) {
            combineHeights('mobile');
            $('body').css({ overflow: 'hidden', position: 'fixed' });
          }
          else {
            $combinedHeights = 0;
            $('body').css({ overflow: 'auto', position: 'relative' });
          }

          if ($mobileRow.hasClass('is-active')) {
            // Set megamenu max-height.
            const $mobileMenuHeight = $(
              '.header__top-container',
              context
            ).outerHeight();

            if ($(window).innerHeight() < $mobileMenuHeight) {
              $mobileRow.find('.header-content').css({
                'padding-top': `${$combinedHeights}px`,
                'padding-bottom': `${
                  $(window).outerWidth() > 1023 ? '0' : '111px'
                }`
              });
            }
            else {
              $mobileRow.find('.header-content').css({
                'overflow-y': 'auto',
                'padding-top': `${$combinedHeights}px`,
                'padding-bottom': `${
                  $(window).outerWidth() > 1023 ? '0' : '111px'
                }`
              });
            }
          }
          else {
            $mobileRow.find('.header-content').css({
              'max-height': 'inherit',
              height: 'auto'
            });
          }
        }

        /**
         * @returns {any} Close Menu on Resize/Close Alert Message
         */
        function closeMenuOnResize() {
          $('body').css({ overflow: 'auto', position: 'relative' });
          $headerContainer.removeClass('is-active');

          if ($(window).outerWidth() > 1023) {
            combineHeights('tablet');
          }

          $megamenuToggleBtn.removeClass('is-active');
          $megamenu
            .removeClass('is-active')
            .attr('aira-expanded', true)
            .attr('aria-hidden', false);
          $marketMenu.removeClass('is-active');
          $mobileRow.removeClass('is-active');
          $mobileToggleBtn.removeClass('is-active');

          if ($megamenuToggleBtn.hasClass('is-active')) {
            $desktopMenuHeight =
              $headerContainer.outerHeight() + $megamenu.outerHeight();

            combineHeights('tablet');
          }
          else if ($(window).outerWidth() < 1024) {
            combineHeights('mobile');
            if ($mobileToggleBtn.hasClass('is-active')) {
              $mobileToggleBtn.removeClass('is-active');
              $mobileRow.removeClass('is-active');
              $megamenuToggleBtn.removeClass('is-active');
            }

            if (!$mobileRow.hasClass('is-active')) {
              $mobileRow.css({
                'max-height': 'inherit',
                height: 'auto'
              });
            }
          }
        }

        // On alert close
        $alertMessage.on('alert:dismissed', function() {
          [$megamenu, $mobileRow].forEach(function($menu, index) {
            if (index === 0) {
              combineHeights('tablet');
              const windowOuterHeight = $(window).outerHeight();
              // Set megamenu max-height.
              $menu.css({
                'max-height': `calc(${windowOuterHeight}px - ${$combinedHeights}px`,
                height: `${windowOuterHeight}px`,
                'overflow-y': 'auto'
              });
            }
            else {
              combineHeights('mobile');
              if ($menu.hasClass('is-active')) {
                const $mobileMenuHeight = $(
                  '.header__top-container',
                  context
                ).outerHeight();

                if ($(window).innerHeight() >= $mobileMenuHeight) {
                  $menu.css({
                    'overflow-y': 'auto'
                  });
                }
              }
              else {
                $menu.css({
                  'max-height': 'inherit',
                  height: 'auto'
                });
              }
            }
          });
          combineHeights($(window).outerWidth() > 1023 ? 'tablet' : 'mobile');
        });

        // Tablet to Desktop Toggle
        $megamenuToggleBtn.unbind().on('click', function() {
          tabletDesktopMenuToggle();
        });

        // Mobile Toggle
        $mobileToggleBtn.unbind().on('click', function() {
          mobileMenuToggle();
        });

        // Create array for header elements.
        // These will apply margin to the fixed header.
        let headerElements = [];

        if ($alertMessage.length > 0) {
          headerElements = [$envIndicator, $alertMessage];
        }
        else {
          headerElements = [$envIndicator];
        }

        // Create margin for header container.
        $.each(headerElements, function() {
          if (typeof $(this).outerHeight() !== 'undefined') {
            $combinedHeights += $(this).outerHeight();
          }
        });

        if ($(window).outerWidth() < 1024) {
          // Apply padding to header container.
          $headerContainer.css({
            'padding-top': `${$combinedHeights}px`,
            'margin-top': '0'
          });
        }
        else {
          // Apply margins to header container.
          $headerContainer.css({
            'margin-top': `${$combinedHeights}px`,
            'padding-top': '0'
          });
        }

        // Add class to donate link.
        $marketMenu.find('.market-menu__item').each(function(i, element) {
          const $menuItem = $(element);
          if (
            $menuItem
              .text()
              .toLowerCase()
              .includes('donate')
          ) {
            $menuItem.addClass('market-menu__item--donate');
          }
        });

        var width = $(window).outerWidth();

        $(window).resize(function() {
          // run only when width changed
          if ($(this).outerWidth() !== width) {
            width = $(this).outerWidth();

            debounce(closeMenuOnResize(), 100, false);
          }
        });
      });
    }
  };
})(document, Drupal, jQuery, Drupal.debounce);
